'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/regexp.prototype.flags/~/function-bind/index.js
// module id = 490
// module chunks = 0